export default __webpack_public_path__ + "assets/images/8400743d3e984c30b77120109e2bffeb.svg";